import Seo from "@/components/Seo";

const Legal = () => (
  <div data-testid="legal-page">
    <Seo
      title="Mentions légales | Fast Alu"
      description="Consultez les mentions légales de Fast Alu."
    />
    <section className="max-w-5xl mx-auto px-6 py-16" data-testid="legal-content">
      <h1 className="font-heading text-4xl uppercase" data-testid="legal-title">
        Mentions légales
      </h1>
      <div className="mt-6 space-y-4 text-brand-ink/70">
        <p data-testid="legal-text-1">
          Ce site est édité par Fast Alu. Pour toute question, contactez-nous par email ou téléphone.
        </p>
        <p data-testid="legal-text-2">
          Responsable de publication : Fast Alu. Hébergement : informations à compléter lors de la mise en ligne.
        </p>
        <p data-testid="legal-text-3">
          Les données collectées via le formulaire sont uniquement utilisées pour répondre à votre demande.
        </p>
      </div>
    </section>
  </div>
);

export default Legal;
